<div class="aw-dialog">
  <div class="aw-dialog-header">Personalization</div>
  <!--<div class="form-sub-header">Select the organization you want to see at a glance.</div>-->

  <!--<div class="settings-item">
    <div class="header">Send Notifications For:</div>
    <div class="radio-group">
      <input name="notification" type="radio" [value]="'all'" [(ngModel)]="settings.notification">
      <span class="name">All activity</span>
    </div>
    <div class="radio-group">
      <input name="notification" type="radio" [value]="'none'" [(ngModel)]="settings.notification">
      <span class="name">Nothing</span>
      <span class="sub-desc">Notifications Off</span>
    </div>
  </div>-->

  <div class="settings-item" style="margin-bottom: 48px;">
    <div class="header">Temperature Unit:</div>
    <div class="radio-group">
      <input name="temp" type="radio" [value]="TemperatureUnit.Fahrenheit" [(ngModel)]="temperatureUnit">
      <span class="name">°F</span>
      <span class="sub-desc">Fahrenheit</span>
    </div>
    <div class="radio-group">
      <input name="temp" type="radio" [value]="TemperatureUnit.Celsius" [(ngModel)]="temperatureUnit">
      <span class="name">°C</span>
      <span class="sub-desc">Celsius</span>
    </div>
  </div>

  <div class="btn-group">
    <button class="aw-btn aw-btn-gray" (click)="onClose(false)">Cancel</button>
    <button class="aw-btn aw-btn-blue" (click)="onSave()">Save</button>
  </div>
</div>
